// Kayaking routes shown on the site, previously the Airtable Routes table.
// Route lines and points drawn on the map are in public/routes/<routeLayer>.json.
import forgottenRigaCard from 'routeImages/forgotten-riga-card.jpg'
import forgottenRigaCover from 'routeImages/forgotten-riga-cover.jpg'
import greenRigaCard from 'routeImages/green-riga-card.jpg'
import greenRigaCover from 'routeImages/green-riga-cover.jpg'
import sunriseRouteCard from 'routeImages/sunrise-route-card.jpg'
import sunriseRouteCover from 'routeImages/sunrise-route-cover.jpg'
import urbanJungleCard from 'routeImages/urban-jungle-card.jpg'
import urbanJungleCover from 'routeImages/urban-jungle-cover.jpg'
import midnightKayakingCard from 'routeImages/midnight-kayaking-card.jpg'
import midnightKayakingCover from 'routeImages/midnight-kayaking-cover.jpg'
import seasideExpeditionCard from 'routeImages/seaside-expedition-card.jpg'
import seasideExpeditionCover from 'routeImages/seaside-expedition-cover.jpg'
import natureTrailCard from 'routeImages/nature-trail-card.jpg'
import natureTrailCover from 'routeImages/nature-trail-cover.jpg'
import islesOfRigaCard from 'routeImages/isles-of-riga-card.jpg'
import islesOfRigaCover from 'routeImages/isles-of-riga-cover.jpg'
import customExpeditionCard from 'routeImages/custom-expedition-card.jpg'
import customExpeditionCover from 'routeImages/custom-expedition-cover.jpg'
import { TKayakingRoute } from 'components/ProjectSpecificComponents/Stores/GlobalStore'

export const KAYAKING_ROUTES: TKayakingRoute[] = [
  {
    label: 'Forgotten Riga',
    difficulty: 'Easy',
    km: 7,
    lengthFrom: 1.5,
    lengthTo: 3,
    cardImgUrl: forgottenRigaCard,
    imgUrl: forgottenRigaCover,
    desc: 'Explore the waterside cottages and calm flow of the Zunda canal, old river docks, and a variety of dazzling yachts docked at the city yacht club. The green microadventure is our easiest and calmest route, perfect for beginners with less water traffic and a great dose of unique sights from the quieter and calmer side of RIGA city. This route can be experienced both ways and easily combined or extended with most of our longer adventures.',
    routeLayer: '/routes/forgotten-riga.json'
  },
  {
    label: 'Green Riga',
    difficulty: 'Easy',
    km: 12,
    lengthFrom: 2,
    lengthTo: 4,
    cardImgUrl: greenRigaCard,
    imgUrl: greenRigaCover,
    desc: 'Explore some of the greenest isles in Riga on a fresh route along the left bank of the river. After passing the National Library of Latvia, your adventure starts at the famous Lucavsala isle with its unique eco-community, semi-rural garden houses, and a very wild bending connecting canal to the little Daugava section. Finish your journey with a picturesque view of the grandiose TV tower on Zaķusala isle and a fresh cup of coffee near the Circle K gas station. It has access from a boat pier (marked on the map)',
    routeLayer: '/routes/green-riga.json'
  },
  {
    label: 'Sunrise route',
    difficulty: 'Medium',
    km: 11,
    lengthFrom: 2,
    lengthTo: 4,
    cardImgUrl: sunriseRouteCard,
    imgUrl: sunriseRouteCover,
    desc: 'Catch the first rays of light on the river along the very best parts of Riga city. Start with the bird song-filled greenery of the Zunda canal and follow along over the Daugava river further into the sleepy old Riga city. The route proceeds through the city parks, central fountain, freedom monument, National Opera of Latvia, under a huge shopping center, central bus station, and back out in Daugava river near the scenic railway bridge.',
    routeLayer: '/routes/sunrise-route.json'
  },
  {
    label: 'Urban Jungle',
    difficulty: 'Hard',
    km: 21,
    lengthFrom: 4.5,
    lengthTo: 9,
    cardImgUrl: urbanJungleCard,
    imgUrl: urbanJungleCover,
    desc: 'Explore the industrial part of RIGA, giant cargo ships, high cranes, stacks of shipping containers, and large-scale machinery in a steampunk wonderland. Route follows the river Daugava along the harbor, dry docks, and further through Sarkandaugava to the greener part of Kundziņsala. On your way back you’ll see Voleri terminal, low-scale summer housing, and riverside cottages. With the last leg of the journey through the calmer waters of the Zunda canal.',
    routeLayer: '/routes/urban-jungle.json'
  },
  {
    label: 'Midnight kayaking',
    difficulty: 'Easy',
    km: 8,
    lengthFrom: 1.5,
    lengthTo: 3,
    cardImgUrl: midnightKayakingCard,
    imgUrl: midnightKayakingCover,
    desc: 'It’s only after sunset that the city truly becomes alive. Discover the ultimate fairytale experience on the most famous RIGA kayaking trail. Your journey unfolds with a grand view of the city panorama through the monumental Vanšu bridge as beams of light rise over the skyline. Next comes quiet parks with warm lighting, wandering notes from street musicians, and views of the world-famous Theatre, Opera, and several other iconic buildings, located near the waterfront. Remember to capture the illuminated foot bridges as you finish jour journey on the other side of old Riga near the railway bridge. After that it\'s a straight line over the river back to the harbor.',
    routeLayer: '/routes/midnight-kayaking.json'
  },
  {
    label: 'Seaside expedition',
    difficulty: 'Hard',
    km: 37,
    lengthFrom: 7,
    lengthTo: 12,
    cardImgUrl: seasideExpeditionCard,
    imgUrl: seasideExpeditionCover,
    desc: 'For the more experienced explorers, test your skills and endurance limits on one of our most challenging expeditions combining the best parts of industrial Riga, the port area, and if weather permits, both of the scenic lighthouses at the end of the pier. On your way back marvel at the greener part of Riga along with waterside cottages, the famous isle of hearts with a hidden white sanded oasis, and calmer waters of the Zunda canal. Be sure to pack enough snacks or stop by near Sarkandaugava Virši or Circle K cafe for a quick hot dog, coffee, or a set of warm sushi rolls.',
    routeLayer: '/routes/seaside-expedition.json'
  },
  {
    label: 'Nature trail',
    difficulty: 'Hard',
    km: 22,
    lengthFrom: 4.5,
    lengthTo: 9,
    cardImgUrl: natureTrailCard,
    imgUrl: natureTrailCover,
    desc: 'Test your endurance and reach the outskirts of Riga city further down along the Green Riga trail. Highlights of this route include all the attractions from the Green Riga trail plus Ķengarags promenade, birdwatching tower, beach, and a calm rest stop near Katlakalna church. Be extra careful when entering the canal near the Dienvidu bridge, as the water there can be rather shallow during summer. For the most enduring explorers, the route can be extended by an extra 10km further reaching the picturesque Daugava museum along the old riverbed path.',
    routeLayer: '/routes/nature-trail.json'
  },
  {
    label: 'Isles of Riga',
    difficulty: 'Medium',
    km: 14,
    lengthFrom: 2.5,
    lengthTo: 5,
    cardImgUrl: islesOfRigaCard,
    imgUrl: islesOfRigaCover,
    desc: 'Enjoy one of our calmest and greenest nature kayaking experiences on an adventurous 12km route. Your journey starts with a view of the National Library of Latvia, a secret passage along the Kīleveina ditch (marked on the map), and further into the Bieķengrāvis with less motor traffic and a narrow atmospheric boat canal. After reaching the TV tower, the second part of the journey continues back along with Lucavsala and Zaķusala isles past the open-air city park, and public beach, and towards the finish near the boat pier.',
    routeLayer: '/routes/isles-of-riga.json'
  },
  {
    label: 'Custom expedition',
    difficulty: 'POI',
    km: null,
    lengthFrom: 1,
    lengthTo: 16,
    cardImgUrl: customExpeditionCard,
    imgUrl: customExpeditionCover,
    desc: 'The world is your Oyster! Create your own kayaking adventure, try combining different routes or choose a completely new destination. Sunrise, afternoon, midnight, summer, winter, autumn, or spring our team is always ready to assist and give advice and recommendations on your next expedition plans. For more experienced adventurers we also offer kayak transport, stormproof covers, specialized navigation equipment, kayak lights, winter gloves, and detailed adventure plans in most of Latvia.'
  }
]
